import CustodiesView from "./custodies-view.js";

export default [
	{
		path: "",
		component: CustodiesView,
	},
];
